// © Microsoft Corporation. All rights reserved.

/**
 * Standardized cookie category enum.
 */
export enum StandardizedCookieCategory {
    Essential = "ES",
    Advertising = "AD",
    SocialMedia = "SM",
    ThirdPartyAnalytics = "AL"
}

/**
 * OneTrust specific cookie category enum.
 */
export enum OneTrustCookieCategory {
    /** Strictly Necessary Cookies */
    C0001 = "C0001",

    /** Advertising Cookies */
    C0002 = "C0002",

    /** Social Media Cookies */
    C0003 = "C0003",

    /** 3rd Party Analytics */
    C0004 = "C0004"
}

export const StandardizedToOneTrustCategoryMapping: {[key in StandardizedCookieCategory]: OneTrustCookieCategory} = {
    [StandardizedCookieCategory.Essential]: OneTrustCookieCategory.C0001,
    [StandardizedCookieCategory.Advertising]: OneTrustCookieCategory.C0002,
    [StandardizedCookieCategory.SocialMedia]: OneTrustCookieCategory.C0003,
    [StandardizedCookieCategory.ThirdPartyAnalytics]: OneTrustCookieCategory.C0004
};